import { ErrorInstance } from '@components/providers/ErrorProvider';

export class HardError extends Error {
  readonly errorCtx: ErrorInstance;

  constructor(error: ErrorInstance) {
    super('Hard error encountered, proceeding with custom handling.');

    this.name = 'HardError';
    this.errorCtx = error;
  }
}
